import OrderTotalSummary from './OrderTotalSummary';

export default OrderTotalSummary;
